/** Routes of the company lists (epic 2026-09-25-chopbook-company-lists). */

/** Research ▸ Company Lists: every list in the firm. */
export const COMPANY_LISTS_PATH = "/research/company-lists";

/** One list, with its side panel (`?company=<id>`). */
export const COMPANY_LIST_ROUTE = "/research/company-lists/:listId";

export function companyListPath(listId: string): string {
  return `${COMPANY_LISTS_PATH}/${encodeURIComponent(listId)}`;
}

/** The company record as a page ("Open as page" from the panel). */
export const COMPANY_PAGE_ROUTE = "/companies/:companyId";

export function companyPagePath(companyId: string): string {
  return `/companies/${encodeURIComponent(companyId)}`;
}

/** The feature flag / page id every company-list screen is gated on. */
export const COMPANY_LISTS_PAGE_ID = "company-lists";
